/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-08 09:45:01
 */
import { Tabs } from "antd";
import React from "react";
import LiveCategory from "./liveCategory";
import SpecialClassification from "../specialClassification";
export default function LiveCategoryComposition() {
  return (
    <Tabs defaultActiveKey="1">
      <Tabs.TabPane tab="直播分类" key="1">
        <LiveCategory />
      </Tabs.TabPane>
      <Tabs.TabPane tab="课程分类" key="2">
        <SpecialClassification />
      </Tabs.TabPane>
    </Tabs>
  );
}
